import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Mention as TiptapMention } from '@tiptap/extension-mention';
import suggestion from '@/components/tiptap/extensions/Mention/suggestion';
import mentionDetailsPlugin from '@/components/tiptap/extensions/Mention/plugins/MentionDetailsPlugin';
import Suggestion from '@tiptap/suggestion';

const MentionSuggestionPluginKey = new PluginKey('mentionSuggestion');

const _mention = TiptapMention.extend({
  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        pluginKey: MentionSuggestionPluginKey,
        char: '@',
        command: ({ editor, range, props }) => {
          const nodeAfter = editor.view.state.selection.$to.nodeAfter;
          const overrideSpace = nodeAfter?.text?.startsWith(' ');

          if (overrideSpace) {
            range.to += 1;
          }

          editor
            .chain()
            .focus()
            .insertContentAt(range, [
              {
                type: this.name,
                attrs: { ...props, mentionSuggestionChar: '@' },
              },
              {
                type: 'text',
                text: ' ',
              },
            ])
            .run();

          editor.view.dom.ownerDocument.defaultView?.getSelection()?.collapseToEnd();
        },
        allow: ({ state, range }) => {
          const $from = state.doc.resolve(range.from);
          const type = state.schema.nodes[this.name];
          return !!$from.parent.type.contentMatch.matchType(type);
        },
        ...this.options.suggestion,
      }) as unknown as Plugin,
      mentionDetailsPlugin,
    ];
  },
});

const Mention = _mention.configure({
  HTMLAttributes: {
    class: 'tiptap-mention',
  },
  renderText({ node }) {
    return `${node.attrs.label ?? node.attrs.id}`;
  },
  renderHTML({ options, node }) {
    return ['span', options.HTMLAttributes, `${node.attrs.label ?? node.attrs.id}`];
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  suggestion,
});

export default Mention;
